/**
 * Centralized route constants
 * Single source of truth for all application paths
 */

/**
 * Base route paths
 */
export const ROUTE_PATHS = {
  // Public routes
  HOME: '/',
  PUBLIC_POOL: '/public-pool',
  CONNECT_WALLET: '/connect-wallet',
  DOCUMENTATION: '/documentation',
  CONTACTS: '/contacts',
  NOT_FOUND: '/not-found',

  // Authentication routes
  LOGIN: '/login',
  SIGNUP: '/signup',
  RESET_PASSWORD: '/reset-password',
  NEW_PASSWORD: '/new-password',
  CONFIRM_EMAIL: '/confirm-email',
  VERIFY_2FA: '/verify-2fa',

  // Wallet confirmation route
  CONFIRM_WALLET: '/user/activate_await_address',

  // Protected routes
  STATISTICS: '/statistics',
  PROFILE: '/profile',
  SETTINGS: '/settings'
} as const

/**
 * Route names
 */
export const ROUTE_NAMES = {
  // Public routes
  HOME: 'home',
  PUBLIC_POOL: 'public-pool',
  USER_PROFILE: 'user-profile',
  WORKER_PROFILE: 'worker-profile',
  CONNECT_WALLET: 'connect-wallet',
  DOCUMENTATION: 'documentation',
  CONTACTS: 'contacts',
  NOT_FOUND: 'not-found',

  // Authentication routes
  LOGIN: 'login',
  SIGNUP: 'signup',
  RESET_PASSWORD: 'reset-password',
  NEW_PASSWORD: 'new-password',
  CONFIRM_EMAIL: 'confirm-email',
  VERIFY_2FA: 'verify-2fa',

  // Wallet confirmation route
  CONFIRM_WALLET: 'confirm-wallet',

  // Protected routes
  STATISTICS: 'statistics',
  PROFILE: 'profile',
  SETTINGS: 'settings'
} as const
